import { render, staticRenderFns } from "./DockingStationSettingsView.vue?vue&type=template&id=6ddab732&lang=pug&"
import script from "./DockingStationSettingsView.vue?vue&type=script&lang=js&"
export * from "./DockingStationSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports